module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338600/introduction01_sp-c5306728b9c2800abd9b22f07a5af6a1.png";